import * as React from 'react';
import { reduxForm, InjectedFormProps, Field, submit } from 'redux-form';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { showModal, closeModal } from 'modules/modal';
import { updateArticleSettings } from 'redux/modules/magazine/article/articlesettings';
import { IUserPreferences } from 'models/user/userpreferences';
import {
	IManageArticleSettings,
	IManageArticleSettingsAction,
	IArticleSettings,
} from 'models/magazine/article/articlesettings';
import { IModalAction } from 'models/modal';
import { Modal, LoadingOverlayWrapper, Button } from 'components';
import { ErrorPage } from 'containers';
import { ButtonsSection, PortalPageSection } from 'components/PortalStructure';
import { PortalSwitchField } from 'components/FormControls';
require('./style.css');

interface IProps extends InjectedFormProps {
	userPreferences?: IUserPreferences;
	manageArticleSettings: IManageArticleSettings;
	initialValues: IManageArticleSettings;
	showHeaderCloseButton?: boolean;
	pristine: boolean;
	submitting: boolean;
	handleSubmit: any;
	updateArticleSettings: (articleSettings: IArticleSettings) => IManageArticleSettingsAction;
	t?: (key: string) => string;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	change: (field: string, value: string) => void;
	submit: (formName: string) => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminArticleSettingsForm extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	private updateArticleSettings(articleSettings: IArticleSettings) {
		this.props.updateArticleSettings(articleSettings);
	}

	private onSubmit(form: any) {
		this.updateArticleSettings(form.articleSettings);
		this.props.closeModal();
	}

	private closeModal() {
		this.props.closeModal();
	}

	public render() {
		if (this.props.manageArticleSettings.error) {
			return <ErrorPage {...this.props} message={this.props.manageArticleSettings.message} />;
		}

		const { pristine, submitting, handleSubmit, t, showHeaderCloseButton } = this.props;
		const { isFetching } = this.props.manageArticleSettings;
		const { isAdministrator, isEditor } = this.props.userPreferences;

		let renderLoader = false;
		if (isFetching) {
			renderLoader = true;
		}

		let content = null;
		if (isAdministrator || isEditor) {
			content = (
				<>
					<div className="row">
						<div className="col-md-12">
							<Field
								name="articleSettings.listed"
								component={PortalSwitchField}
								type="checkbox"
								label={t('Magazine_Article_ArticleSettings_Label_Listed')}
							/>
						</div>
					</div>
					,
					<div className="row">
						<div className="col-md-12">
							<Field
								name="articleSettings.onlyForMembers"
								component={PortalSwitchField}
								type="checkbox"
								label={t('Magazine_Article_ArticleSettings_Label_OnlyForMembers')}
							/>
						</div>
					</div>
					,
				</>
			);
		}

		return (
			<Modal
				modalClass="articleSettingsModal"
				title={t('Magazine_Article_ArticleSettings_Title')}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={this.closeModal}
			>
				<LoadingOverlayWrapper active={renderLoader} spinner={true} text={t('BSPortal_Common_Loading')}>
					<form onSubmit={handleSubmit(this.onSubmit)}>
						<PortalPageSection usage="admin">{content}</PortalPageSection>
						<ButtonsSection>
							<div className="row">
								<div className="col-sm-12">
									<Button type="submit" usage="admin" disabled={pristine || submitting}>
										{t('BSPortal_Common_SaveAndClose')}
									</Button>
								</div>
							</div>
						</ButtonsSection>
					</form>
				</LoadingOverlayWrapper>
			</Modal>
		);
	}
}

let AdminArticleSettings = reduxForm({
	form: c.FORM_NAME_MANAGE_ARTICLESETTINGS,
	enableReinitialize: true,
})(AdminArticleSettingsForm);

AdminArticleSettings = connect(
	(state: IStore) => {
		return {
			userPreferences: state.userPreferences,
			manageArticleSettings: state.manageArticleSettings,
			initialValues: state.manageArticleSettings,
		};
	},
	(dispatch) => ({
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
		submit: (formName: string) => dispatch(submit(formName)),
		updateArticleSettings: (articleSettings: IArticleSettings) => dispatch(updateArticleSettings(articleSettings)),
	}),
)(AdminArticleSettings);

export { AdminArticleSettings };
